export default __webpack_public_path__ + "static/media/ic_drag.de1aab91.svg";